<template>
    <!-- <div>
        <order-item v-for="item in items" :key="item.id" :order="item"></order-item>
    </div> -->
    <div class="orderlistPage">
        <van-nav-bar
        title="我的订单"     
        left-arrow
        @click-left="onClickLeft"
        />
        <van-list
        v-model="loading"
        :finished="finished"
        @load="onLoad"
        class="orderList"
        >
            <van-row  v-for="item in list" :key="item.id" :title="item.name + ''" class="item">
                <div class="baseInfo">
                    <van-col class="left"><img :src="item.img|defaultPic"></van-col>
                    <van-col class="middle">
                        <van-row><van-col class="orderNo">订单编号：{{item.orderId}}</van-col></van-row>
                        <van-row v-for="sitem in item.orderDetail" :key="sitem" class="orderDetail"><van-col class="name">{{sitem}}</van-col><van-col class="quantities">x 1</van-col></van-row>
                        <van-row v-if="item.phone"><van-col class="contact">{{item.receiverName|defaultName}}/{{item.phone}}</van-col></van-row>
                        <van-row v-if="item.address"><van-col class="address">{{item.address | ellipsis}}</van-col></van-row>
                        <van-row v-show="item.showFillAddressBtn"><van-col><van-button size="small" @click="fillAddr(''+item.orderId)">补充地址信息</van-button></van-col></van-row>
                    </van-col>
                    <van-col class="right">{{item.amount/100|currency}}</van-col>
                </div>
                <div class="wuliuInfo" v-show="item.wuliu">
                    <van-row>
                        <van-col class="left"><img src="../../static_niunai/img/wuliu.png"></van-col>
                        <van-col class="right">{{item.wuliu}}</van-col>
                    </van-row>
                </div>
            </van-row>
        </van-list>
        <van-submit-bar
          button-text="刷新"
          @submit="refresh"
          class="logout"
          >         
        </van-submit-bar>   
    </div>
</template>
<script>
// import OrderItem from '../components/common/OrderItem'
import Vue from 'vue';
import click_handler from "../tools/mgtv/click";
import { page_view, click_event } from "../tools/mgtv/analysis";
import { Row, Col,Button,List, Toast,SubmitBar  } from 'vant';
import {getOrderList} from '../api/getData'
import {OrderProduct,GoProduct, giftQuantity} from '../constant/products'
import {login, logout} from '../tools/mgtv/login'
import {mapState, mapActions} from 'vuex'
import { isApp } from '../tools/mgtv/env';
Vue.use(Row).use(Col).use(Button).use(List).use(SubmitBar);
Vue.filter('defaultPic' , function(value) {
    return !value?"static_niunai/img/s1.jpg":value;
});
Vue.filter('defaultName' , function(value) {
    return !value?"未填写":value;
});
Vue.filter('ellipsis' , function(value) {
    return value.length>12?value.slice(0,16) +'...':value;
});
export default {
    name:"order-list",
    components: {
    },
    data(){
        let orderList=[
            // {id:"1",title:"牛奶盒子预售方案",phone:'15200812186',name:'网名9527',address:'湖南省长沙市开福区洪山街道金鹰小区1#2U205',price:20,img:'https://img.yzcdn.cn/public_files/2017/12/18/fd78cf6bb5d12e2a119d0576bedfd230.png'},
            // {id:"2",title:"牛奶盒子预售方案",price:20,img:'https://img.yzcdn.cn/public_files/2017/12/18/fd78cf6bb5d12e2a119d0576bedfd230.png'},
            // {id:"3",title:"牛奶盒子预售方案",price:20,img:'https://img.yzcdn.cn/public_files/2017/12/18/fd78cf6bb5d12e2a119d0576bedfd230.png'},
            // {id:"4",title:"牛奶盒子预售方案",price:20,img:'https://img.yzcdn.cn/public_files/2017/12/18/fd78cf6bb5d12e2a119d0576bedfd230.png'},
            // {id:"5",title:"牛奶盒子预售方案",price:20,img:'https://img.yzcdn.cn/public_files/2017/12/18/fd78cf6bb5d12e2a119d0576bedfd230.png'}
        ]
        return {
            list:orderList,
            loading: false,
            finished: false
            }
    },
  computed: {
        ...mapState([
            'actInfo',
            'userInfo',
            'deviceInfo',
            'urlParams',
            'ticket',
            'product'
        ]),
        isH5:function(){
            return !isApp();
        }
  },
//   watch:{
//       userInfo(curVal,oldval){
//           if(curVal&&curVal.uuid){
//             //获取当前用户订单
//             this.onLoad()
//           }
//       }
//   }
//     ,
    mounted(){
        page_view("订单列表页",this)
        this.onLoad()
    }
    ,
    inject:['reload'],
    methods: {
        onLoad() {
            if(!this.ticket){                
                this.loading = false;
                this.finished = true;
                // this.$dialog.alert({
                //     message: '登录信息已过期，请重新登录'
                // }).then(logout).catch(() => {
                //     console.log('取消')
                // });
                // this.$router.go(-1)
                return
            }
            this.loading = true;
            const ticket = this.ticket
            console.log("orderlist ticket",ticket)
            getOrderList(ticket).then(res => {            
                if(res && res.err==0){
                    
                    let i=0
                    res.data.forEach(element => {
                        let item = {}
                        item.id = i+"_"+element.productId
                        item.orderId = element.orderId
                        item.deliverTime = element.deliverTime
                        item.orderSeq = element.orderSeq
                        item.rank = element.rank
                        item.phone = element.phone
                        item.receiverName = element.receiverName
                        item.address = element.address
                        item.amount = element.amount
                        item.showFillAddressBtn = false
                        if(element.productId==OrderProduct.id){//购买的是预售产品
                            item.name = OrderProduct.name
                            item.orderDetail = OrderProduct.orderDetail                        
                        }
                        else if(element.productId==GoProduct.id){//购买的是现货产品
                            item.name = GoProduct.name
                            // //每天前100展示礼物清单
                            // let orderDetailWithoutGift =[]
                            // orderDetailWithoutGift.push(GoProduct.orderDetail[0])
                            // item.orderDetail = element.rank<=giftQuantity?GoProduct.orderDetail:orderDetailWithoutGift
                            item.orderDetail = GoProduct.orderDetail
                            //物流信息
                            item.wuliu = item.deliverTime=="7"?GoProduct.wuliu[0]:GoProduct.wuliu[0]
                            if(item.address ==''){
                                item.showFillAddressBtn = true
                            }
                        }
                        this.list.push(item)
                        i++;
                    });
                    this.loading = false;
                    this.finished = true;
                }
                else{
                    this.loading = false;
                    this.finished = true;
                    Toast(res.msg)
                }
            })
        },
        fillAddr(orderId){
            this.$router.push({path:`/Address/${orderId}`,query:this.$route.query});
        },
        onClickLeft(){
            this.$router.push({path:`/`,query:this.$route.query});
        },
        refresh(){
            click_handler('订单列表页-刷新', () => {
                this.reload()
            },{},
        this);
        },
        getList(){

            
        }
  }
    
}
</script>
<style lang="stylus">
    @import "../share/mixins.styl"
    .orderlistPage
        padding-bottom 1rem        
        .orderList
            background-color #eeeeee
            .item
                margin-top 0.1rem
                padding 0.2rem 0 0.2rem 0
                background-color white
                .baseInfo
                    overflow hidden
                    padding-bottom 0.12rem
                    img
                        width 100%
                        padding  0.2rem
                
                    .left,.middle,.right
                        
                    .left
                        width 1rem
                    .middle
                        width 5rem
                        .van-row
                            padding-top 0.1rem

                        .orderDetail
                            display flex
                        .name
                            font-size 0.3rem
                            line-height 0.42rem
                            width 100%
                            white-space nowrap
                            overflow hidden
                            text-overflow ellipsis         
                            flex 16
                        .quantities
                            flex 2
                            opacity 0.4
                        .orderNo,.contact,.address
                            color #0B0E1A
                            opacity 0.4
                            font-size 0.26rem
                            overflow hidden 
                            text-overflow ellipsis 
                            white-space nowrap
                            width 100%
                        .orderNo
                            opacity 1
                            color #0B0E1A
                            font-size 0.26rem
                    .right
                        width 0.7rem
                        font-size 0.3rem
                        color #F06000
                        padding 0.48rem 0 0 0.38rem

                .wuliuInfo
                    .van-row
                        border-top 1px solid #eeeeee
                        line-height 0.37rem                    
                        margin  0 0.5rem
                        padding 0.2rem 0 0 0
                        display flex
                        .van-col
                            font-size 0.26rem
                            img
                                width 0.44rem
                                height 0.33rem
                        .left
                            flex 1
                        .right
                            flex 10
                            padding-left 0.24rem 
            .item:nth-child(1)    
                margin-top 0
        .logout
            background-color red
        .van-submit-bar__bar
            width 100%
            height: auto

        .van-submit-bar
            .van-button
                display block
                margin 0 auto
                width 7.5rem
                height 0.9rem
                line-height 0.9rem
                background-image linear-gradient(-180deg, #FFEBA4 3%, #E0B580 100%)
                letter-spacing 0.5em
                font-size 0.32rem
                color #0B0E1A
                border none
        .van-submit-bar__price
            flex 0
            padding-right 0

</style>


// WEBPACK FOOTER //
// src/pages/OrderList.vue